// 电桩详情--基础信息
import React, { PureComponent } from "react";
import { Modal, Spin, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import fetchHandler from "@/fetch/fetchHandler";
import { electricalLossUpdate } from "@/fetch/fetchApi";
// 国际化切换语言
// 引入组件
import StubFrameWorkList from "./stubFrameWorkList";
import DbmHistory from "./dbmHistory";
import ElectricalLossEdit from "./electricalLossEdit";

// eslint-disable-next-line arrow-parens
@connect(state => state)
class StubDetailInfo extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubDetailInfo;
    this.state = {
      result: {},
      seeframeWorkVisible: false,
      edited: false,
    };
    this.query = {};
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
  }

  componentWillMount() {
    this.getStubDetail();
  }

  // 获取电桩详情
  getStubDetail() {
    this.setState({
      result: this.props.stubInfoData,
      stubSpinning: false,
    });
  }

  handleStubStatusLogClick = () => {
    this.stubIdData = this.state.result.key;
    this.modalVisibleAction("seeDetailVisible", true);
    this.setState({
      seeDetailVisible: true,
    });
  };

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  // 固件升级记录按钮点击
  handleStubframeWorkClick = () => {
    this.stubIdData = this.state.result.key;
    this.modalVisibleAction("seeframeWorkVisible", true);
    this.setState({
      seeframeWorkVisible: true,
    });
  };

  // 信号强度历史记录
  handleDbmHistoryClick = () => {
    this.stubIdData = this.state.result.key;
    this.modalVisibleAction("dbmHistoryVisible", true);
  };

  // 电损修改
  handleSubmitElEdit = () => {
    const values = this.elRef.handleSubmit();

    fetchHandler(electricalLossUpdate, {
      ...values,
      stubId: this.state.result.key,
    }).then((res) => {
      if (res && res.code === "success") {
        message.success("修改成功");
        // 刷新列表
        this.props.refreshGrid();

        this.setState({
          edited: false,
          result: {
            ...this.state.result,
            ...values,
          },
        });
      }
    });
  };

  render() {
    return (
      <Spin spinning={this.state.stubSpinning}>
        <div className="sc-modal-scroll">
          <div className="page-panel">
            <div className="page-info-item">
              <h3>
              {/* 基本信息 */}
                <span>{this.internationalization.title1}：</span>
              </h3>
              <ul>
                <li className="stationName">
                {/* 电站ID */}
                  <strong>{this.internationalization.title2}：</strong>
                  <span>{this.state.result.key}</span>
                </li>
                <li className="stationName">
                {/* 电站名称 */}
                  <strong>{this.internationalization.title3}：</strong>
                  <span>{this.state.result.stubGroupName}</span>
                </li>

                <li className="stationName">
                  <strong>{this.internationalization.title4}：</strong>
                  <span>{this.state.result.name}</span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title5}：</strong>
                  <span>
                    {
                      this.state.result.type === "0" ? this.internationalization.title6 : ""
                    }
                    {
                      this.state.result.type === "1" ? this.internationalization.title7 : ""
                    }
                    {
                      (this.state.result.type !== "0" && this.state.result.type !== "1") ? this.internationalization.title8 : ""
                    }
                  </span>
                </li>

                <li className="stationName">
                  <strong>{this.internationalization.title9}：</strong>
                  <span>{this.state.result.modelNo}</span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title10}：</strong>
                  <span>{this.state.result.statusName}</span>
                </li>

                <li className="stationName">
                  <strong>{this.internationalization.title12}：</strong>
                  <span>{this.state.result.existsGun === "0" ? "否" : "是"}</span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title13}：</strong>
                  <span>{this.state.result.voltageUpperLimit}</span>
                </li>

                <li className="stationName">
                  <strong>{this.internationalization.title14}：</strong>
                  <span>{this.state.result.voltageLowerLimit}</span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title15}：</strong>
                  <span></span>
                </li>

                <li className="stationName">
                  <strong>{this.internationalization.title16}：</strong>
                  <span></span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title17}：</strong>
                  <span>{this.state.result.voltageAuxiliary}</span>
                </li>
              </ul>
            </div>
            <div className="page-info-item">
              <h3>
                <span>{this.internationalization.title18}</span>
              </h3>
              <ul>
                <li className="stationName">
                  <strong>{this.internationalization.wz1}：</strong>
                  <span>
                    {this.state.result.frameWork !== "--" && this.state.result.updateType !== "--"
                      ? `${this.state.result.updateType}-${this.state.result.frameWork}`
                      : "--"}
                    &nbsp;&nbsp;
                    <a onClick={this.handleStubframeWorkClick}>升级记录</a>
                  </span>
                </li>
                {/* <li className={'stationName'}>
                                    <strong>固件型号：</strong>
                                    <span>{this.state.result.frameWork}</span>
                                </li> */}
              </ul>
            </div>
            <div className="page-info-item">
              <h3>
                <span>{this.internationalization.title21}</span>
              </h3>
              <ul>
                <li className="stationName">
                  <strong>{this.internationalization.title22}：</strong>
                  <span>{this.state.result.iccid}</span>
                </li>
                <li className="stationName">
                  <strong>信号强度：</strong>
                  <span>
                    {this.state.result.signal || "--"}dBm{" "}
                    {this.state.result.signalUpdateTime
                    && this.state.result.signalUpdateTime !== "--"
                      ? `(${this.state.result.signalUpdateTime})`
                      : null}{" "}
                    &nbsp;&nbsp;<a onClick={this.handleDbmHistoryClick}>历史记录</a>
                  </span>
                </li>
              </ul>
            </div>
            <div className="page-info-item">
              <div style={{ display: "flex", alignItems: "center" }}>
                <h3>
                  <span>电损系数</span>
                </h3>
                <EditOutlined
                  style={{ fontSize: "16px", marginLeft: "10px" }}
                  onClick={() => this.setState({ edited: true })}
                />
              </div>
              <ul>
                <li className="stationName">
                  <strong>待机功率：</strong>
                  <span>{this.state.result.standbyPower}kW</span>
                </li>
                <li className="stationName">
                  <strong>充电效率：</strong>
                  <span>{this.state.result.chargingEfficiency}%</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <Modal
          title="升级记录"
          visible={this.state.seeframeWorkVisible}
          footer={null}
          destroyOnClose
          width="1100px"
          onCancel={() => {
            this.modalVisibleAction("seeframeWorkVisible", false);
          }}>
          <StubFrameWorkList stubId={this.stubIdData} />
        </Modal>
        <Modal
          width={600}
          title="历史记录"
          visible={this.state.dbmHistoryVisible}
          footer={null}
          destroyOnClose
          onCancel={() => {
            this.modalVisibleAction("dbmHistoryVisible", false);
          }}>
          <DbmHistory stubId={this.stubIdData} />
        </Modal>
        <Modal
          title="电损系数配置"
          visible={this.state.edited}
          destroyOnClose
          onCancel={() => this.setState({ edited: false })}
          onOk={this.handleSubmitElEdit}>
          <ElectricalLossEdit info={this.state.result} ref={(ref) => (this.elRef = ref)} />
        </Modal>
      </Spin>
    );
  }
}

export default injectIntl(StubDetailInfo);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubDetailInfo.js